import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/goodsBorrow/applyList',
    name: 'goodsBorrowApplyList',
    component: () => import('@/sub-app/goodsBorrow/pages/applyList.vue'),
    meta: {
      title: '物品借用', // 借用列表
      keepAlive: true,
    },
  },
  {
    path: '/goodsBorrow/applyDetail',
    name: 'goodsBorrowApplyDetail',
    component: () => import('@/sub-app/goodsBorrow/pages/applyDetail.vue'),
    meta: {
      title: '物品借用', // 借用详情
      keepAlive: false,
    },
  },
  {
    path: '/goodsBorrow/apply',
    name: 'goodsBorrowApply',
    component: () => import('@/sub-app/goodsBorrow/pages/apply.vue'),
    meta: {
      title: '物品借用',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  document.title = to.meta?.title || '';
  next();
});

export default router;
